import { useEffect } from 'react';

import { Campaign } from '../../../../types/Campaign';
import CampaignCreativeTypeCard from './CampaignCreativeTypeCard';
import Column from '../../../../components/Column';

export type CampaignWizardCreativeStepProps = {
    campaign: Campaign;
    onChange(value: Partial<Campaign>): void;
};

export default function CampaignWizardCreativeStep(props: CampaignWizardCreativeStepProps) {
    const { campaign, onChange } = props;

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, []);

    return (
        <Column gap={3}>
            <CampaignCreativeTypeCard campaign={campaign} onChange={onChange} />
        </Column>
    );
}
